export const GET_TICKETS_REQUEST = 'GET_TICKETS_REQUEST';
export const GET_TICKETS_SUCCESS = 'GET_TICKETS_SUCCESS';
export const GET_TICKETS_FAILURE = 'GET_TICKETS_FAILURE';

export const GET_TICKET_REQUEST = 'GET_TICKET_REQUEST';
export const GET_TICKET_SUCCESS = 'GET_TICKET_SUCCESS';
export const GET_TICKET_FAILURE = 'GET_TICKET_FAILURE';

export const SUBMIT_TICKETS_REQUEST = 'SUBMIT_TICKETS_REQUEST';
export const SUBMIT_TICKETS_SUCCESS = 'SUBMIT_TICKETS_SUCCESS';
export const SUBMIT_TICKETS_FAILURE = 'SUBMIT_TICKETS_FAILURE';

export const SET_TICKETS = 'SET_TICKETS';
export const SET_TICKET = 'SET_TICKET';

export const SET_SUBMIT_TICKET_SUCCESS = 'SET_SUBMIT_TICKET_SUCCESS';
export const SET_SUBMIT_TICKET_FETCHING = 'SET_SUBMIT_TICKET_FETCHING';

export const CLOSE_PING_EVENT_TICEKTS = 'CLOSE_PING_EVENT_TICEKTS';

export const GET_EXPORT_REQUEST = 'GET_EXPORT_REQUEST';
export const GET_EXPORT_SUCCES = 'GET_EXPORT_SUCCES';
export const GET_EXPORT_FAILURE = 'GET_EXPORT_FAILURE';

export const GET_COMPANY_PLANS_REQUEST = 'GET_COMPANY_PLANS_REQUEST';
export const GET_COMPANY_PLANS_SUCCESS = 'GET_COMPANY_PLANS_SUCCESS';
export const GET_COMPANY_PLANS_FAILURE = 'GET_COMPANY_PLANS_FAILURE';

export const GET_NON_INSTALLATION_REASONS_REQUEST = 'GET_NON_INSTALLATION_REASONS_REQUEST';
export const GET_NON_INSTALLATION_REASONS_SUCCESS = 'GET_NON_INSTALLATION_REASONS_SUCCESS';
export const GET_NON_INSTALLATION_REASONS_FAILURE = 'GET_NON_INSTALLATION_REASONS_FAILURE';

export const getExportTicketRequest = (filters = {}, type ) => ({
    type: GET_EXPORT_REQUEST,
    payload:{
        filters,
        type
    }
})
export const getExportTicketSucces = (type , tickets ) => ({
    type: GET_EXPORT_SUCCES,
    payload:{
        tickets,
        type
    }
})
export const getExportTicketFailure = err => ({
    type: GET_EXPORT_FAILURE,
    error:err
})

export const getTicketsRequest = (filters = {}, type = "installations") => ({
    type: GET_TICKETS_REQUEST,
    payload: {
        filters,
        type
    }
});

export const getTicketsSuccess = (tickets, total, type = "installations") => ({
    type: GET_TICKETS_SUCCESS,
    payload: {
        tickets,
        total,
        type
    }
});

export const getTicketsFailure = err => ({
    type: GET_TICKETS_FAILURE,
    error: err
});

export const getCompanyPlansRequest = (companyId) => ({
    type: GET_COMPANY_PLANS_REQUEST,
    payload: {
        companyId
    }
});

export const getCompanyPlansSuccess = (company, plans, total) => ({
    type: GET_COMPANY_PLANS_SUCCESS,
    payload: {
        company,
        plans,
        total
    }
});

export const getCompanyPlansFailure = (err) => ({
    type: GET_COMPANY_PLANS_FAILURE,
    error: err
});

export const getTicketRequest = (filters = {}, type = "installations") => ({
    type: GET_TICKET_REQUEST,
    payload: {
        filters,
        type
    }
});

export const getTicketSuccess = (ticket, type = "installations") => ({
    type: GET_TICKET_SUCCESS,
    payload: {
        ticket,
        type
    }
});

export const getTicketFailure = err => ({
    type: GET_TICKET_FAILURE,
    error: err
});

export const setTickets = (tickets = [], total = 0) => ({
    type: SET_TICKETS,
    payload: {
        tickets,
        total
    }
});

export const setTicket = (ticket = {}) => ({
    type: SET_TICKET,
    payload: {
        ticket
    }
});

export const setSumitTicketSuccess = (success = false) => ({
    type: SET_SUBMIT_TICKET_SUCCESS,
    payload: {
        success
    }
});

export const setSumitTicketFetching = (submitFetching = false, eventFetching = false) => ({
    type: SET_SUBMIT_TICKET_FETCHING,
    payload: {
        submitFetching,
        eventFetching
    }
});

export const submitTicketsRequest = (ticket, type = "installations") => ({
    type: SUBMIT_TICKETS_REQUEST,
    payload: {
        ticket,
        type
    }
});

export const submitTicketsSuccess = (ticket = {}) => ({
    type: SUBMIT_TICKETS_SUCCESS,
    payload: {
        ticket
    }
});

export const submitTicketsFailure = err => ({
    type: SUBMIT_TICKETS_FAILURE,
    error: err
});

export const closePingEventTicket = () => ({
    type: CLOSE_PING_EVENT_TICEKTS
});

export const getNonInstallationReasonsRequest = () => ({
    type: GET_NON_INSTALLATION_REASONS_REQUEST
});

export const getNonInstallationReasonsSuccess = (reasons) => ({
    type: GET_NON_INSTALLATION_REASONS_SUCCESS,
    payload: { reasons }
});

export const getNonInstallationReasonsFailure = (err) => ({
    type: GET_NON_INSTALLATION_REASONS_FAILURE,
    error: err
});
